import axios from 'axios'
import store from '@/store'
import router from '@/router'

let service = axios.create({
  baseURL: process.env.BASE_API,
  timeout: 15000
})

service.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers['math-access-token'] = store.getters.token
  }
  return config
}, error => {
  console.log(error)
  return Promise.reject(error)
})

service.interceptors.response.use(response => response,
error => {
  console.log(error)
  store.commit('SET_USER', {
    phone: '',
    QX: 0
  })
  router.push({ name: 'login' })
  return Promise.reject(error)
})

export default service



// WEBPACK FOOTER //
// ./src/utils/fetch.js